import store from "../../../store";
import { CREATE_TICKET_DATA, CREATE_TICKET_ERROR, CREATE_TICKET_HIDE_ERROR, CREATE_TICKET_START_LOADER, CREATE_TICKET_STOP_LOADER, } from "../interface/CreateTickets";
class createTicketActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    createTicketData(data) {
        this.dispatch({
            type: CREATE_TICKET_DATA,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CREATE_TICKET_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CREATE_TICKET_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: CREATE_TICKET_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CREATE_TICKET_STOP_LOADER,
        });
    }
}
export default createTicketActions;
